<template>
  <div class="jewelry-slider">
    <DefTitle v-if="result?.messages?.title" :result="1" :center="true">
      <h2>
        {{ result.messages.title }}
      </h2>
    </DefTitle>
    <DefSwiper :settings="settings">
      <SwiperSlide v-for="(item, i) in result.items" :key="i">
        <JewelryCard :result="item" />
      </SwiperSlide>
    </DefSwiper>
    <SliderAllButton :href="result.link.href">{{ result.link.name }}</SliderAllButton>
  </div>
</template>

<script setup>
import { SwiperSlide } from 'swiper/vue';
import JewelryCard from '@components/card/JewelryCard/JewelryCard.vue';
import DefSwiper from '@components/Def/DefSwiper/DefSwiper.vue';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import SliderAllButton from '@components/sliders/SliderAllButton.vue';

const props = defineProps({
  result: {
    type: Object,
  },
});

const settings = {
  slidesPerView: 1,
  breakpoints: {
    768: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 16,
    },
    968: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 16,
    },
  },
};
</script>

<style lang="scss" scoped>
.jewelry-slider {
  margin-bottom: 56px;
  @include point-md {
    margin-bottom: 80px;
  }
  @include point-lg {
    margin-bottom: 100px;
  }
  :deep(.def-title) {
    @include point-md {
      margin-bottom: 24px;
    }
    @include point-lg {
      margin-bottom: 32px;
    }
  }
}
</style>
